/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Text } from "components/Text";
import { FitinsurAPI, MessageCenter } from "utils";
import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import { Content, LayoutCircle, Section, Spacer } from "./styles";
import { LoaderContext } from '@fitinsur/contexts';

const StepNavigation = ({ idOperation, idProduct, stage, ignoreOperationRoot, permissions }) => {
  const history = useHistory();
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();
  const [isMasterPolicy, setIsMasterPolicy] = useState(null);
  const [operation, setOperation] = useState({});

  function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur
      .requestOperationInfo(idOperation)
      .then((response) => response.json())
      .then((response) => {
        setOperation(response);
        setIsMasterPolicy(
          response.isMasterPolicy || response.isMasterPolicyRoot
        );
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data: \n" + error);
      });
  }

  useEffect(() => {
    if (idOperation) getOperationInfo();
  }, []);

  const checkOperationRoute = (idOperation, step) => {
    if (stage === step || !idOperation) return;

    fitinsur.setAuthToken(authContext.token);
    updateIsLoadingStatus(true);

    fitinsur
      .requestPolicyNavigation(idOperation)
      .then((x) => x.json())
      .then((res) => {
        updateIsLoadingStatus(false);
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details);
          return;
        }

        let {
          route,
          idOperationRoot,
          idProduct,
          idDomain,
          idNavigation,
          lastOperationQuestionnaireId,
          isBound,
        } = res.ret_value;


        if (step !== 3 || route) {
          if (step == 1) idProduct == 57 ? history.push(`/credit-analysis/edit/${idProduct}/${idOperation}`) : history.push(`/edit-enquiry/${idProduct}/${idOperation}`,
            { idProduct: idProduct, disabled: idOperationRoot === null, endorsement: idOperation || false });

          if (step == 2) {
            if ([55, 56].includes(idProduct) && idDomain === 254) history.push({ pathname: `/adjustments-and-corrections/${idOperation}` });
            if (operation?.idDomainStatusDocument) {
              const plansPage = (idProduct === 9004 ? 'plans-rcg' : 'plans');
              idProduct == 57 ? history.push(`/credit-analysis/ccg/${idProduct}/${idOperation}`) :
                history.push({ pathname: `/quote/${plansPage}/${idProduct || 34}/${idOperation}` });
            }
          }
        }
        else if (step == 3) {
          if ([55, 56].includes(idProduct) && idDomain === 254) {
            history.push({ pathname: `/adjustments-and-corrections/${idOperation}` })
          } else {
            history.push({ pathname: route });
          }
        }
        else {
          updateIsLoadingStatus(false);
        }
      }).catch((e) => updateIsLoadingStatus(false));
  };

  return (
    <Content>
      <Section>
        <LayoutCircle
          isActive={stage === 1}
          onClick={() => checkOperationRoute(idOperation, 1)}
        >
          {" "}
          1{" "}
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true}>
          INFORMAÇÕES BÁSICAS
        </Text>
      </Section>

      <Spacer className="d-sm-none"></Spacer>
      <Section>
        <LayoutCircle
          isActive={stage === 2}
          onClick={() => checkOperationRoute(idOperation, 2)}
        >
          {" "}
          2{" "}
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true}>
          NEGOCIAÇÃO EM ANDAMENTO
        </Text>
      </Section>

      <Spacer className="d-sm-none"></Spacer>
      <Section>
        <LayoutCircle
          isActive={stage === 3}
          onClick={() => checkOperationRoute(idOperation, 3)}
        >
          {" "}
          3{" "}
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true}>
          EFETIVAÇÃO E DOCUMENTOS
        </Text>
      </Section>
    </Content>
  );
};

export default StepNavigation;
